module.exports = __webpack_public_path__ + "static/florence-1655830_1920-69af50d25fd095a84b730c54f3f3f546.png";